import $ from 'jquery';
let ajaxReq = null;

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds.
const debounce = ( func, wait ) => {
	let timeout;

	return function executedFunction( ...args ) {
		const later = () => {
			clearTimeout( timeout );
			func( ...args );
		};

		clearTimeout( timeout );
		timeout = setTimeout( later, wait );
	};
};

var searchSuggestions = debounce( function( val ) {
	const currentVal = $( '.js-autocomplete-search' ).val();
	ajaxReq = $.ajax( {
		url : rootworks.endpoints.search,
		type : 'POST',
		dataType: 'html',
		data: { val: val },
		beforeSend: function() {
			if ( ajaxReq != null ) {
				ajaxReq.abort();
			}
		},
		success : function( response ) {
			if ( currentVal === val ) {
				$( '.js-search-suggestions' ).removeClass( 'u-hidden' );
				if ( response ) {
					$( '.js-search-suggestions' ).html( '<ul>' + response + '</ul>' );
				} else {
					$( '.js-search-suggestions' ).html( '<p>No results.</p>' );
				}
			}
		},
		complete: function() {
			ajaxReq = null;
		},
	} );
}, 400 );

$( document ).on( 'input', '.js-autocomplete-search', function() {
	const $self = $( this );
	const val = $self.val();

	if ( val.length > 2 ) {
		searchSuggestions( val );
	} else {
		if ( ajaxReq != null ) {
			ajaxReq.abort();
		}
		$( '.js-search-suggestions' ).addClass( 'u-hidden' );
	}
} );
